import { interpolate } from '../../global';
import { ILanguageResources, ITranslationModule } from '../../interfaces'; // adjust path as needed

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.SupplierQuoteItemContentType.';
  public static readonly typeToDisplay = `${Id.prefix}typeToDisplay`;
}

export class LangSupplierQuoteItemContentType {
  private constructor() {}
  public static toDisplay(resourceDisplayValue, unitType: string): string {
    return interpolate(Id.typeToDisplay, { resourceDisplayValue }, unitType === 'none' ? null : unitType);
  }
}

export class SupplierQuoteItemContentTypeModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register
      .add(
        Id.typeToDisplay,
        '{{resourceDisplayName}}',
        'Display the name for a Supplier Quote Item by type and also with unit type'
      )
      .addSegment('individual', '{{resourceDisplayName}} (individual)')
      .addSegment('a2', '{{resourceDisplayName}} (area squared)')
      .addSegment('length', '{{resourceDisplayName}} (length)')
      .addSegment('none', '{{resourceDisplayName}}');
  }
}
